import type { RouteRecordRaw } from 'vue-router';

export const subAdminRoutes: Array<RouteRecordRaw> = [
  {
    path: '/subscription/admin',
    name: 'subAdmin',
    redirect: '/subscription/admin/service',
    component: () => import('pages/micros/subscription/SubscriptionAdmin.vue'),
    meta: {
      title: 'Subscription Administration',
      requiresAuth: true,
    },
    children: [
      {
        path: 'service',
        name: 'subService',
        redirect: '/subscription/admin/service/list',
        component: () => import('pages/micros/subscription/services/SubService.vue'),
        meta: {
          title: 'Subscription Services',
          requiresAuth: true,
        },
        children: [
          {
            path: 'new',
            name: 'subServiceNew',
            component: () => import('pages/micros/subscription/services/SubServiceNew.vue'),
            meta: {
              title: 'New Subscription Service',
              requiresAuth: true,
            },
          },
          {
            path: 'list',
            name: 'subServiceList',
            component: () => import('pages/micros/subscription/services/SubServiceList.vue'),
            meta: {
              title: 'Subscription Services List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'subServiceDetail',
            component: () => import('pages/micros/subscription/services/SubServiceDetail.vue'),
            meta: {
              title: 'Subscription Service Detail',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'app/service',
        name: 'appService',
        redirect: '/subscription/admin/app/service/list',
        component: () => import('pages/micros/subscription/appservice/AppService.vue'),
        meta: {
          title: 'Subscription Application-Services',
          requiresAuth: true,
        },
        children: [
          {
            path: 'new',
            name: 'appServiceNew',
            component: () => import('pages/micros/subscription/appservice/AppServiceNew.vue'),
            meta: {
              title: 'New Subscription Application-Service',
              requiresAuth: true,
            },
          },
          {
            path: 'list',
            name: 'appServiceList',
            component: () => import('pages/micros/subscription/appservice/AppServiceList.vue'),
            meta: {
              title: 'Subscription Application-Services List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'appServiceDetail',
            component: () => import('pages/micros/subscription/appservice/AppServiceDetail.vue'),
            meta: {
              title: 'Subscription Application-Service Detail',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'service/cost',
        name: 'serviceCost',
        redirect: '/subscription/admin/service/cost/list',
        component: () => import('pages/micros/subscription/servicecost/ServiceCost.vue'),
        meta: {
          title: 'Subscription Service Costs',
          requiresAuth: true,
        },
        children: [
          {
            path: 'new',
            name: 'serviceCostNew',
            component: () => import('pages/micros/subscription/servicecost/ServiceCostNew.vue'),
            meta: {
              title: 'New Subscription Service Cost',
              requiresAuth: true,
            },
          },
          {
            path: 'list',
            name: 'serviceCostList',
            component: () => import('pages/micros/subscription/servicecost/ServiceCostList.vue'),
            meta: {
              title: 'Subscription Service Costs List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'serviceCostDetail',
            component: () => import('pages/micros/subscription/servicecost/ServiceCostDetail.vue'),
            meta: {
              title: 'Subscription Service Cost Detail',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'service/task',
        name: 'serviceTask',
        redirect: '/subscription/admin/service/task/list',
        component: () => import('pages/micros/subscription/servicetask/ServiceTask.vue'),
        meta: {
          title: 'Subscription Service Tasks',
          requiresAuth: true,
        },
        children: [
          {
            path: 'new',
            name: 'serviceTaskNew',
            component: () => import('pages/micros/subscription/servicetask/ServiceTaskNew.vue'),
            meta: {
              title: 'New Subscription Service Tasks',
              requiresAuth: true,
            },
          },
          {
            path: 'list',
            name: 'serviceTaskList',
            component: () => import('pages/micros/subscription/servicetask/ServiceTaskList.vue'),
            meta: {
              title: 'Subscription Service Tasks List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'serviceTaskDetail',
            component: () => import('pages/micros/subscription/servicetask/ServiceTaskDetail.vue'),
            meta: {
              title: 'Subscription Service Task Detail',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'order/service/:orderId?',
        name: 'orderService',
        component: () => import('pages/micros/subscription/OrderSubService.vue'),
        meta: {
          title: 'Pay and Order Subscription Service [Admin]',
          requiresAuth: true,
        },
      },
      {
        path: 'cancel/service/:orderId?',
        name: 'cancelService',
        component: () => import('pages/micros/subscription/CancelSubService.vue'),
        meta: {
          title: 'Cancel Subscription Service',
          requiresAuth: true,
          pageGroup: 'admin',
        },
      },
      {
        path: 'app/service/usage',
        name: 'adminAppServiceUsage',
        component: () => import('pages/micros/subscription/AppServiceUsage.vue'),
        meta: {
          title: 'Subscription Application-Service-Usage [Admin]',
          requiresAuth: true,
          pageGroup: 'admin',
        },
      },
      {
        path: 'pricing',
        name: 'servicePricing',
        component: () => import('pages/micros/subscription/SubServicePricing.vue'),
        meta: {
          title: 'Subscription Services Pricing [Admin]',
          requiresAuth: true,
          pageGroup: 'admin',
        },
      },

      {
        path: 'user/app',
        name: 'adminUserApp',
        redirect: '/subscription/admin/user/app/list',
        component: () => import('pages/central/user/app/UserApp.vue'),
        meta: {
          title: 'Subscription User-Application Assignment',
          requiresAuth: true,
          pagePath: 'subscription/user/app',
          pageGroup: 'subscriber',
        },
        children: [
          {
            path: 'list',
            name: 'adminUserAppList',
            component: () => import('pages/central/user/app/UserAppList.vue'),
            meta: {
              title: 'Subscription User-Application Assignment List',
              requiresAuth: true,
              pagePath: 'subscription/user/app/list',
              pageGroup: 'subscriber',
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'adminUserAppDetail',
            component: () => import('pages/central/user/app/UserAppDetail.vue'),
            meta: {
              title: 'Subscription User-Application Assignment Detail',
              requiresAuth: true,
              pagePath: 'subscription/user/app/detail',
              pageGroup: 'subscriber',
            },
          },
          {
            path: 'new',
            name: 'adminUserAppNew',
            component: () => import('pages/central/user/app/UserAppNew.vue'),
            meta: {
              title: 'New Subscription User-Application Assignment',
              requiresAuth: true,
              pagePath: 'subscription/user/app/new',
              pageGroup: 'subscriber',
            },
          },
        ],
      },
      {
        path: 'user/role',
        name: 'adminUserRole',
        redirect: '/subscription/admin/user/role/list',
        component: () => import('pages/central/user/role/UserRole.vue'),
        meta: {
          title: 'Subscription User-Role Assignment',
          requiresAuth: true,
          pagePath: 'subscription/user/role',
          pageGroup: 'subscriber',
        },
        children: [
          {
            path: 'list',
            name: 'adminUserRoleList',
            component: () => import('pages/central/user/role/UserRoleList.vue'),
            meta: {
              title: 'Subscription User-Role Assignment List',
              requiresAuth: true,
              pagePath: 'subscription/user/role/list',
              pageGroup: 'subscriber',
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'adminUserRoleDetail',
            component: () => import('pages/central/user/role/UserRoleDetail.vue'),
            meta: {
              title: 'Subscription User-Role Assignment Detail',
              requiresAuth: true,
              pagePath: 'subscription/user/role/detail',
              pageGroup: 'subscriber',
            },
          },
          {
            path: 'new',
            name: 'adminUserRoleNew',
            component: () => import('pages/central/user/role/UserRoleNew.vue'),
            meta: {
              title: 'New Subscription User-Role Assignment',
              requiresAuth: true,
              pagePath: 'subscription/user/role/new',
              pageGroup: 'subscriber',
            },
          },
        ],
      },
    ],
  },
];
